import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M22 9h-5.586l5.293-5.293-1.414-1.414L15 7.586V2h-2v9h9V9zM2 15h5.586l-5.293 5.293 1.414 1.414L9 16.414V22h2v-9H2v2z" }));
export default createSvgIcon(iconPath, "Collapse");
//# sourceMappingURL=CollapseIcon.js.map